import cn from 'classnames';
import { useIntl } from 'react-intl';
import { Element } from 'react-scroll';

const AziendaManagement = () => {
  const intl = useIntl();
  return (
    <div className="snf-lx-components-azienda-management">
      <Element name="management">
        <div className={cn('div-image', `snf-bg-repeat-no-repeat`)}>
          <div className="container-fluid padding snf-text-color-black p-2 p-md-4 p-md-5">
            <div className="row ml-1 ml-md-2 mb-2 mt-5 mt-md-0">
              <div className="col-auto snf-font-32 snf-text-color-black mb-4">
                {intl.formatMessage(
                  {
                    defaultMessage: '<strong>Il Management</strong>'
                  },
                  {
                    strong: (chunks) => <strong>{chunks}</strong>
                  }
                )}
              </div>
            </div>

            <div className="row ml-1 ml-md-2 mb-2">
              <div className="col-auto snf-font-16 snf-font-md-24 mb-4">
                {intl.formatMessage({
                  defaultMessage:
                    // 'La nostra è una struttura costituita in larga parte da figure provenienti da IBM Italia, per assicurare la continuità delle operazioni e l’allineamento strategico del business. '
                    'La nostra è una struttura costituita da un mix di professionisti alcuni dei quali  provenienti da IBM Italia, al fine di assicurare la continuità delle operazioni e l’allineamento strategico del business con la casa madre.'
                })}
              </div>
            </div>
            <div className="py-5" />

            <div className="row justify-content-around w-100 mt-5 no-gutters mb-4">
              <div className="col-12 wrapper"> </div>

              <div className="col-md-3 ombra mb-4">
                <div className="row no-gutters mb-5 justify-content-center">
                  <div className="col-auto">
                    <img
                      className="img w-100"
                      alt="Immagine Francesco Stronati"
                      src="/images/management-stronati.png"
                    />
                  </div>
                </div>
                <div className="row no-gutters">
                  <div className="col-12 text-center snf-font-18">
                    {intl.formatMessage(
                      {
                        defaultMessage: '<strong>FRANCESCO STRONATI</strong>'
                      },
                      {
                        strong: (chunks) => <strong>{chunks}</strong>
                      }
                    )}
                  </div>
                </div>
                <div className="row no-gutters mb-3">
                  <div className="col-12 px-2 text-center snf-font-14 snf-text-color-dark-grey snf-font-w6">
                    {intl.formatMessage({
                      defaultMessage: 'Presidente, Vicepresidente di IBM Italia'
                    })}
                  </div>
                </div>
                <div className="row px-3 no-gutters mb-3">
                  <div className="col-auto text-center snf-font-14">
                    {intl.formatMessage(
                      {
                        defaultMessage:
                          'Guida la direzione del <strong>settore pubblico</strong> e della <strong>sanità di IBM Italia.</strong>'
                      },
                      {
                        strong: (chunks) => <strong>{chunks}</strong>
                      }
                    )}
                  </div>
                </div>
              </div>

              <div className="w-100 d-block d-lg-none" />

              <div className="col-md-3 ombra mb-4">
                <div className="row no-gutters mb-5 justify-content-center">
                  <div className="col-md-7">
                    <img
                      className="img w-100"
                      alt="Immagine Stefano Brambilla"
                      src="/images/ad-management.jpeg"
                    />
                  </div>
                </div>
            <div className="row no-gutters justify-content-center">
                <div className="col-12 text-center snf-font-18">
                  {intl.formatMessage(
                    {
                      defaultMessage: '<strong>STEFANO BRAMBILLA</strong>'
                    },
                    {
                      strong: chunks => <strong>{chunks}</strong>
                    }
                  )}
                </div>
              </div>
              <div className="row no-gutters mb-3 justify-content-center">
                <div className="col-12 px-2 text-center snf-font-14 snf-text-color-dark-grey snf-font-w6">
                  {intl.formatMessage({
                    defaultMessage: 'Amministratore Delegato'
                  })}
                </div>
              </div>
              <div className="row px-3 no-gutters mb-3 justify-content-center">
                <div className="col-auto text-center snf-font-14">
                  {intl.formatMessage(
                    {
                      defaultMessage:
                        `Stefano ha maturato una solida esperienza nella <strong>guida di organizzazioni complesse</strong> e nella <strong>gestione di percorsi di trasformazione</strong>.

                         Per <strong>oltre 15 anni, nel Regno Unito</strong>, ha ricoperto ruoli di responsabilità in <strong>contesti internazionali</strong>.

                         Oggi alla guida di Sistemi Informativi, accompagnerà l'Azienda nella prossima fase di sviluppo, rafforzandone il posizionamento sul mercato e creando valore attraverso <strong>innovazione, competenze e capacità di execution</strong>.`
                    },
                    {
                      strong: chunks => <strong>{chunks}</strong>
                    }
                  )}
                </div>
              </div>
            </div>

              <div className="w-100 d-block d-xl-none" />

              <div className="col-md-3 ombra mb-4">
                <div className="row no-gutters mb-5 justify-content-center">
                  <div className="col-auto ">
                    <img
                      className="img w-100"
                      alt="Immagine Pio Petricca"
                      src="/images/management-petricca.png"
                    />
                  </div>
                </div>
                <div className="row no-gutters justify-content-center">
                  <div className="col-12 text-center snf-font-18">
                    {intl.formatMessage(
                      {
                        defaultMessage: '<strong>PIO PETRICCA</strong>'
                      },
                      {
                        strong: (chunks) => <strong>{chunks}</strong>
                      }
                    )}
                  </div>
                </div>
                <div className="row no-gutters mb-3">
                  <div className="col-12 px-2 text-center snf-font-14 snf-text-color-dark-grey snf-font-w6">
                    {intl.formatMessage({
                      defaultMessage: 'Chief Financial Officer (CFO)'
                    })}
                  </div>
                </div>
                <div className="row px-3 no-gutters mb-3">
                  <div className="col-auto text-center snf-font-14">
                    {intl.formatMessage(
                      {
                        defaultMessage:
                          'Nella sua lunga carriera in IBM ha ricoperto posizioni chiave in ambito <strong>finance</strong>, sia a livello <strong>italiano</strong> che <strong>internazionale</strong>.'
                      },
                      {
                        strong: (chunks) => <strong>{chunks}</strong>
                      }
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Element>
    </div>
  );
};

AziendaManagement.displayName = "L'Azienda Management ";
export { AziendaManagement };
